/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import '../../../common/newsSlider/newsSlider.scss';

import { validation, validateForm } from '../../../../utils/validation';
//#region  importing the common components
import { Button, Input, ValidationMessage, Modal } from '../../../../component';
//#endregion
const PNRComponent = (props) => {
  const {
    imgSource,
    title,
    parentClassName,
    className,
    returnPNRData,
    intl,
    gatewayName,
    direction,
    loading,
    showPnrModal,
  } = props;

  // states for managing

  const [PNR, setPNR] = useState(''),
    [showModal, setShowModal] = useState(false),
    [lastName, setLastName] = useState(''),
    [errors, setErrors] = useState(''),
    [showLoading, setShowLoading] = useState(loading);

  // function of close modal

  // form validation function
  const handleValidation = () => {
    let { error, result } = validateForm({
      lastName: validation.english(lastName).required().errors,
      PNR: validation.code(PNR).required().errors,
    });
    return { result, error };
  };
  const closeModal = () => {
    setShowModal(false);
  };

  // function of close modal

  const pnrHelpModal = () => {
    // jq('#pnrHelp').modal('show');
    return (
      <Modal
        id="pnrHelp"
        isOpen={showModal}
        onClose={closeModal}

        // title={intl.formatMessage({ id: 'booking.pnrhelp' })}
      >
        {renderPnrHelp()}
      </Modal>
    );
  };

  // details of pnrHelp modal

  const renderPnrHelp = () => {
    return (
      <div className="d-flex w-100 justify-content-start px-md-3 px-0">
        <div className="d-flex col-12 p-0 justify-content-start text-muted text-start flex-column font-weight-bold">
          <div className="d-flex py-2 text-primary font-weight-bold">
            <FormattedMessage id="booking.pnrsteps" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.enteryour" />
          </div>
          {/* <div className="d-flex flex-row flex-wrap p-2">
            {`${intl.formatMessage({
              id: "booking.enteryour",
            })} ${
              direction === "rtl"
                ? `${intl.formatMessage({
                    id: "booking.panel",
                  })} ${gatewayName}  ${intl.formatMessage({
                    id: "booking.enter",
                  })}`
                : `${gatewayName} ${intl.formatMessage({
                    id: "booking.panel",
                  })}`
            }`}
          </div> */}
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.openreference" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr3" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <div className="d-flex">
              <FormattedMessage id="booking.entercommand" />
            </div>
            <div className="d-flex text-primary font-weight-bold px-2">
              esthri428cx-b
            </div>
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <div className="d-flex">
              <FormattedMessage id="booking.savepnr" />
            </div>
            <div className="d-flex text-primary font-weight-bold px-2">
              Rfxx;er
            </div>
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr6" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr7" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr8" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr9" />
          </div>
          <div className="d-flex flex-row flex-wrap p-2">
            <FormattedMessage id="booking.pnr10" />
          </div>
          {/* <div className="d-flex py-2">
            <FormattedMessage id="booking.laststep" />
          </div> */}
        </div>
        <div className="d-flex w-100 py-2 justify-content-start" />
      </div>
    );
  };

  // use effects for loading and modal

  useEffect(() => {
    setShowLoading(props.loading);
  }, [props.loading]);
  return (
    <div className={`${parentClassName}`}>
      <div className={`${className}`}>
        <div className="newsCard__image-container pb-4">
          <img
            style={{ minHeight: '22vh' }}
            className="newsCard__image"
            src={require(`../../../../content/images/elements/${imgSource}`)}
            alt=""
          />
        </div>

        {/* this section for fade to show image */}

        <svg className="newsCard__svg" viewBox="0 0 800 500">
          {/* <path
						d='M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400 L 800 500 L 0 500'
						stroke='transparent'
						fill='#f5f7fb'
					/> */}
          {/* <path
						className='newsCard__line'
						d='M 0 100 Q 50 200 100 250 Q 250 400 350 300 C 400 250 550 150 650 300 Q 750 450 800 400'
						stroke='pink'
						strokeWidth={3}
						fill='transparent'
					/> */}
        </svg>

        {/* this section for title text*/}

        <div className="d-flex col-12 p-0">
          <div className="d-flex col-11 p-0 newsCard__content text-start">
            <p
              className={`text-third text-wrap ${
                direction === 'rtl'
                  ? 'font-md-smaller font-small'
                  : 'font-md-msmall font-small'
              }`}
            >
              <FormattedMessage id={title} />
            </p>
          </div>
        </div>

        {/* this section for office id */}

        <div className="d-flex w-100 pt-2 mt-2 px-0 flex-column">
          <span
            className={`text-secondary ${
              direction === 'rtl' ? 'font-small' : 'font-msmall'
            }`}
          >
            <FormattedMessage id="booking.officeid" />
          </span>
          <span
            className={`text-primary ${
              direction === 'rtl' ? 'font-small' : 'font-msmall'
            }`}
          >
            THRI428CX
          </span>
        </div>

        {/* this section about pnrhelping and after click open modal for help */}

        <div className="d-flex justify-content-end text-purple font-small py-3 ">
          <div
            className="border-bottom border-primary cursor-pointer text-primary"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <FormattedMessage id="booking.pnrhelp" />
          </div>
        </div>
        {/* inputs for insert information of pnr */}
        <fieldset>
          <Input
            type="text"
            id="PNR"
            name="PNR"
            value={PNR}
            label={props.intl.formatMessage({ id: 'booking.referencenumber' })}
            themeMode="light"
            outSideLabel={true}
            iconUrl={null}
            outSideLabelPosition="top"
            outSideLabelClass={`d-flex justify-content-start ${
              direction === 'rtl' ? 'font-small' : 'font-msmall'
            }`}
            onChange={(event) => {
              setPNR(event.currentTarget.value),
                setErrors({
                  ...errors,
                  PNR: validation.code(event.target.value).required().errors,
                });
            }}
            inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
          />
          <ValidationMessage errors={errors?.PNR} />
        </fieldset>

        <fieldset>
          <Input
            type="text"
            margin="mt-4"
            id="lastName"
            name="lastName"
            value={lastName}
            label={props.intl.formatMessage({ id: 'booking.leadlastname' })}
            themeMode="light"
            outSideLabel={true}
            iconUrl={null}
            outSideLabelPosition="top"
            outSideLabelClass={`d-flex justify-content-start ${
              direction === 'rtl' ? 'font-small' : 'font-msmall'
            }`}
            onChange={(event) => {
              setLastName(event.currentTarget.value),
                setErrors({
                  ...errors,
                  lastName: validation.english(event.target.value).required()
                    .errors,
                });
            }}
            inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
          />
          <ValidationMessage errors={errors?.lastName} />
        </fieldset>

        {/* this section (condition) for show or loading resault  */}
        <fieldset>
          <Button
            name={`show-reverse-pnr`}
            id={`show-reverse-pnr`}
            className="btn-secondary mt-4"
            label={props.intl.formatMessage({
              id: 'booking.showreserve',
            })}
            onClick={() => {
              setShowLoading(true);
              returnPNRData(PNR, lastName);
            }}
            loading={showLoading || showPnrModal}
            disabled={showLoading || !PNR || !handleValidation().result}
          />
        </fieldset>
      </div>
      {/* here show pnr help modal */}
      {pnrHelpModal()}
    </div>
  );
};

// prototypes && defaultprops

PNRComponent.propTypes = {
  parentClassName: PropTypes.string,
  title: PropTypes.string,
  imgSource: PropTypes.string,
  className: PropTypes.string,
};
PNRComponent.defaultProps = {
  parentClassName: '',
  title: 'booking.pnrdesc',
  imgSource: 'flight2.jpg',
  className: '',
};
export default injectIntl(PNRComponent);
